import ModuleDocuments from 'mfOrderManagement/Documents';

/**
 * Simple re-export of the documents module, allowing for mocks
 * (the promise-based alias 'mfOrderManagement/*' can't be mocked directly) to be used in tests
 */
export { ModuleDocuments };
